import { render, staticRenderFns } from "./FormDatepickerSize.vue?vue&type=template&id=2df2fa66"
import script from "./FormDatepickerSize.vue?vue&type=script&lang=js"
export * from "./FormDatepickerSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports